/**
 * @prettier
 * @flow
 */
import { isString } from 'src/utils/string/isString';

export function lowerCase<T: ?string>(value: T): T {
    if (!value || !isString(value)) {
        return value;
    }
    return (value.toLowerCase(): any);
}
